import { Anchor, Box, Grommet, Heading, Layer, Text } from 'grommet'
import React, { Component } from 'react'
import { Switch, Route, useLocation, useParams } from 'react-router-dom'
import { ErrorCard, PageCard } from './components/Cards'
import { MotionLayer } from './components/Motion'
import Toasts from './components/Toasts'
import { AppContext } from './libs/context'
import { setStateForErrorResponse, setStateForNewToast, setStateToRemoveToast } from './libs/notify'
import { meshTheme } from './libs/theme'
import { LogoWithNoTagLine } from './Image'
import { DashboardReportPage } from './components/Corporate'
import { opsAPI } from './api/retail'
import { RoundIconButton, SplashLoader } from './components/Common'
import { AuthUserMenu } from './components/User'
import firebase from './libs/firebase'
import { Button } from 'grommet/es6'
import { CircleQuestion } from 'grommet-icons'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const ClientHeader = ({ children, authUser }) => (
  <Box
    border={{ side: 'bottom', color: 'light-2' }}
    direction="row"
    background="white"
    height={'60px'}
    align={'center'}
  >
    <Box direction="row" flex="grow" pad="small" gap="xxsmall" align={'center'}>
      <Box pad={{ bottom: '6px' }} height={'32px'} width={'150px'}>
        <LogoWithNoTagLine />
      </Box>
      {/*<Heading level={3} margin={'none'}>*/}
      {/*  Reports*/}
      {/*</Heading>*/}
    </Box>
    <Box flex={'grow'} pad="small" align={'end'}>
      {children}
    </Box>
    {authUser && (
      <Box
        fill="vertical"
        pad={{ horizontal: 'xsmall' }}
        width={{ min: 'xsmall' }}
        background={'dark-1'}
      >
        <AuthUserMenu
          fill
          justifyContent={'between'}
          focusIndicator={false}
          dropProps={{
            margin: { top: 'xsmall' }
          }}
          authUser={authUser}
        />
      </Box>
    )}
  </Box>
)
export class ClientApp extends Component {
  showResponseAsError = setStateForErrorResponse.bind(this)
  showAsToast = setStateForNewToast.bind(this)
  removeToast = setStateToRemoveToast.bind(this)
  state = {
    toasts: [],
    error: null,
    apiLoading: false,
    initialLoad: true,
    companyUser: {}
  }
  componentDidMount() {
    console.log('<<<<<<  LOADING CLIENT APP')
    const { path, url } = this.props.match //useRouteMatch()
    firebase
      .analytics()
      .logEvent('page_view', { page_location: url, page_path: path, page_title: 'Client App' })

    this.props.authUser && this.loadData()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.authUser !== this.props.authUser && this.props.authUser) {
      this.setState({ initialLoad: true })
      this.loadData()
    }
  }
  loadData = () => {
    this.setState({ apiLoading: true })

    const companyUser = opsAPI.getFromRetail('clients/company_user', {
      // fields: ['id', 'name', 'logo_image_url']
    })

    const responses = Promise.all([companyUser])
    responses
      .then((result) => {
        const companyUsers = result[0].data.results
        // this.cacheToLocal('companies', companyIdMap)
        const companyUser = companyUsers.length > 0 ? companyUsers[0] : {}
        const defaultCompanyUser = { permissions: this.getPermissions(companyUser) }
        this.setState({
          apiLoading: false,
          companyUser: { ...companyUser, ...defaultCompanyUser },
          initialLoad: false
        })
      })
      .catch((err) => {
        this.setState({ apiLoading: false })
        this.showResponseAsError(err)
      })
  }
  getPermissions = (companyUser) => {
    const allStoreRoleIds = [1, 3] // head office, admin
    const permissions = { canAccessAllStores: false }
    if (companyUser && allStoreRoleIds.indexOf(companyUser.company_user_role) > -1) {
      permissions.canAccessAllStores = true
    }
    return permissions
  }
  render() {
    const { path, url } = this.props.match //useRouteMatch()
    const appContextValue = {
      actions: {
        logout: this.props.logoutAction,
        showResponseAsError: this.showResponseAsError,
        showAsToast: this.showAsToast
      }
    }
    const { error, toasts, apiLoading, initialLoad, companyUser, help } = this.state
    const { authUser } = this.props
    return (
      <Grommet theme={meshTheme} full>
        <AppContext.Provider value={appContextValue}>
          {apiLoading ? (
            <Box fill align={'center'} justify={'center'}>
              {initialLoad && authUser && (
                <SplashLoader
                  authUser={authUser}
                  apiLoading={apiLoading}
                  message={'App is launching..'}
                />
              )}
            </Box>
          ) : (
            !initialLoad &&
            authUser && (
              <Box fill>
                <ClientHeader authUser={authUser}>
                  <RoundIconButton
                    Icon={CircleQuestion}
                    onClick={() => {
                      this.setState({ help: true })
                    }}
                  />
                </ClientHeader>
                <Box direction={'row'} fill background="light-1" overflow={'hidden'}>
                  <Switch>
                    <Route
                      path={path}
                      render={(props) =>
                        companyUser.id ? (
                          <DashboardReportPage {...props} companyUser={companyUser} />
                        ) : (
                          <Box fill align={'center'} justify={'center'}>
                            <Heading level={4}>
                              You are not authorized yet to access FoodMesh. Please get in touch if
                              you are experiencing issues.
                            </Heading>
                          </Box>
                        )
                      }
                    />
                    {/*<Route path={path}>*/}
                    {/*  <h3>You are logged in.</h3>*/}
                    {/*</Route>*/}
                  </Switch>
                </Box>
              </Box>
            )
          )}
          {error && (
            <Layer
              background={'none'}
              onEsc={this.showResponseAsError}
              onClickOutside={this.showResponseAsError}
            >
              <ErrorCard
                closeAction={this.showResponseAsError}
                logoutAction={this.props.logoutAction}
                {...error}
              />
            </Layer>
          )}
          {help && (
            <Layer
              background={'none'}
              onEsc={this.showResponseAsError}
              onClickOutside={this.showResponseAsError}
            >
              <PageCard
                // width={'medium'}
                background={'white'}
                show={help}
                round={'small'}
                elevation={'xlarge'}
                heading={'Support'}
                closeAction={() => this.setState({ help: false })}
              >
                <Box pad={'large'} fill align={'center'} justify={'center'} gap={'small'}>
                  <Box pad={{ bottom: 'medium' }}>
                    <CircleQuestion size={'xlarge'} color={'light-6'} />
                  </Box>
                  <Text size={'large'}>Got questions or need some help?</Text>
                  <Text>
                    Contact{' '}
                    <Anchor label={'support@foodmesh.ca'} href={'mailto:support@foodmesh.ca'} />
                  </Text>
                </Box>
              </PageCard>
            </Layer>
          )}
          {toasts && toasts.length > 0 && (
            <MotionLayer background={'none'} modal={false} position={'bottom-left'}>
              <Toasts toasts={toasts} removeAction={this.removeToast} />
            </MotionLayer>
          )}
        </AppContext.Provider>
      </Grommet>
    )
  }
}
